<ng-container *ngIf="featureTags && !featureTags['sf_href_link']">
  <ng-container *ngFor="let menuItem of categoriesMenu">
    <ng-container
      *ngIf="menuItem.sub_list.length === 0 && menuItem.category_name !== 'ALL' && menuItem.category_name !== 'contact us'">
      <button mat-button class="main-categories" [routerLink]="['/categories', menuItem['category_url']]">
        <span class="icon fa" [ngClass]="menuItem.icon"></span>
        <span class="text-holder">{{menuItem.category_name}}</span>
      </button>
    </ng-container>
    <ng-container *ngIf="menuItem.category_name === 'ALL'">
      <button mat-button class="main-categories" (click)="openSidenav()">
        <mat-icon style="margin-right:6px;">menu</mat-icon>
        <span class="text-holder">{{menuItem.category_name}}</span>
      </button>
    </ng-container>
    <ng-container *ngIf="menuItem.category_name === 'contact us'">
      <button mat-button class="main-categories" [routerLink]="['/contact']">
        <span class="text-holder">{{menuItem.category_name}}</span>
      </button>
    </ng-container>
    <ng-container *ngIf="menuItem.sub_list.length > 0">
      <button #button mat-button
        [routerLink]="menuItem.category_name === 'all categories' ? ['/categories'] : ['/categories', menuItem['category_url']]"
        [matMenuTriggerFor]="levelOne" #levelOneTrigger="matMenuTrigger" (mouseenter)="buttonEnter(levelOneTrigger)"
        (mouseleave)="buttonLeave(levelOneTrigger, button)" class="main-categories">
        <span class="icon fa" [ngClass]="menuItem.icon"></span>
        <span>{{menuItem.category_name}}
          <!-- <i class="fa fa-chevron-down"></i> -->
          <mat-icon class="caret">arrow_drop_down</mat-icon>
        </span>
      </button>
      <mat-menu class="desktop_categories" #levelOne="matMenu" [overlapTrigger]="false" [hasBackdrop]="false">
        <span (mouseenter)="menuenter()" (mouseleave)="menuLeave(levelOneTrigger, button)">
          <!-- <ul > -->
          <ng-container *ngFor="let childL1 of menuItem.sub_list">
            <li *ngIf="childL1['category_name'] !== 'ALL'" class="p-0 sub-menu-one" mat-menu-item
              [routerLink]="menuItem.category_name === 'all categories' ? ['/categories', childL1['category_url']] : ['/categories', menuItem['category_url'], childL1['category_url']]">
              <a class="nav-link">
                {{childL1['category_name']}}
              </a>
            </li>
            <!-- <ng-container *ngIf="childL1.sub_list && childL1.sub_list.length > 0">
            <li mat-menu-item #levelTwoTrigger="matMenuTrigger" [matMenuTriggerFor]="levelTwo">
              <span class="icon fa" [ngClass]="childL1.icon"></span>
              <span>{{childL1.category_name}}</span>
            </li>
  
            <mat-menu #levelTwo="matMenu">
              <span (mouseenter)="menu2enter()" (mouseleave)="menu2Leave(levelOneTrigger,levelTwoTrigger, button)">
              <ng-container *ngFor="let childL2 of childL1.sub_list">
                <li class="p-0" mat-menu-item>
                  <a class="nav-link" [routerLink]="['/categories', childL2['category_url']]">{{childL2.category_name}}
                    <i *ngIf="childL2.icon" [ngClass]="childL2.icon"></i>
                  </a>
                </li>
              </ng-container>
              </span>
            </mat-menu>
          </ng-container> -->
          </ng-container>
          <!-- </ul> -->
        </span>
      </mat-menu>
    </ng-container>
  </ng-container>
  </ng-container>
  
  <div *ngIf="featureTags && featureTags['sf_href_link']" #menuButtonRef>
    <ng-container *ngFor="let menuItem of categoriesMenu">
      <ng-container
        *ngIf="menuItem?.sub_list?.length === 0 && menuItem.category_name !== 'ALL' && menuItem.category_name !== 'MENU' && menuItem.category_name !== 'contact us' && menuItem.category_name !== 'Previously Ordered'">
        <a mat-button class="main-categories" [routerLink]="['/categories', menuItem['category_url']]">
          <span class="icon fa" [ngClass]="menuItem.icon"></span>
          <span class="text-holder">{{menuItem.category_name}}</span>
        </a>
      </ng-container>
      <ng-container *ngIf="menuItem.category_name === 'ALL'">
        <a mat-button class="main-categories" (click)="openSidenav()">
          <mat-icon style="margin-right:6px;">menu</mat-icon>
          <span class="text-holder">{{menuItem.category_name}}</span>
        </a>
      </ng-container>
      <ng-container *ngIf="menuItem.category_name === 'MENU'">
        <a mat-button class="main-categories" (click)="openSidenav()">
          <mat-icon style="margin-right:6px;">menu</mat-icon>
          <span class="text-holder">{{menuItem.category_name}}</span>
        </a>
      </ng-container>
      <ng-container *ngIf="menuItem.category_name === 'contact us'">
        <a mat-button class="main-categories" [routerLink]="['/contact']">
          <span class="text-holder">{{menuItem.category_name}}</span>
        </a>
      </ng-container>
      <ng-container *ngIf="menuItem.category_name === 'Previously Ordered'">
        <button mat-button class="main-categories" [routerLink]="['/previously-ordered']">
          <span class="text-holder">{{menuItem.category_name}}</span>
        </button>
      </ng-container>
      <ng-container *ngIf="menuItem?.sub_list?.length > 0">
        <a #button mat-button
        [routerLink]="menuItem.category_name === 'all categories' ? ['/categories'] : ['/categories', menuItem['category_url']]"
          [matMenuTriggerFor]="levelOne" #levelOneTrigger="matMenuTrigger" (mouseenter)="buttonEnter(levelOneTrigger)"
          (mouseleave)="buttonLeave(levelOneTrigger, button)" class="main-categories">
          <span class="icon fa" [ngClass]="menuItem.icon"></span>
          <span>{{menuItem.category_name}}
            <!-- <i class="fa fa-chevron-down"></i> -->
            <mat-icon class="caret">arrow_drop_down</mat-icon>
          </span>
        </a>
        <mat-menu class="desktop_categories" #levelOne="matMenu" [overlapTrigger]="false" [hasBackdrop]="false">
          <span (mouseenter)="menuenter()" (mouseleave)="menuLeave(levelOneTrigger, button)">
            <!-- <ul > -->
            <ng-container *ngFor="let childL1 of menuItem?.sub_list">
              <a *ngIf="childL1['category_name'] !== 'ALL'" class="p-0 sub-menu-one" mat-menu-item
                [routerLink]="menuItem.category_name === 'all categories' ? ['/categories', childL1['category_url']] : ['/categories', menuItem['category_url'], childL1['category_url']]">
                <a class="nav-link">
                  {{childL1['category_name']}}
                </a>
              </a>
            </ng-container>
            <!-- </ul> -->
          </span>
        </mat-menu>
      </ng-container>
    </ng-container>
  </div>
  